// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"style-module--searchBox--oG0Oh","pageTitle":"style-module--pageTitle--24WuO"};